import { render, staticRenderFns } from "./el_head.vue?vue&type=template&id=e2703490&scoped=true&"
import script from "./el_head.vue?vue&type=script&lang=js&"
export * from "./el_head.vue?vue&type=script&lang=js&"
import style0 from "./el_head.vue?vue&type=style&index=0&id=e2703490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2703490",
  null
  
)

export default component.exports